<section class="gallery">
  <header class="gallery-header">
    <button
      type="button"
      class="gallery-back"
      data-testid="gallery-back"
      (click)="back.emit()"
      [attr.aria-label]="'doktar_app.common.back' | translate">
      <i class="ph ph-caret-left"></i>
    </button>
    <h3 class="gallery-title">{{ titleKey | translate }}</h3>
    @if (periodStart && periodEnd) {
      <p class="gallery-period">
        {{
          'doktar_app.common.date_x_to_y'
            | translate
              : {
                  arg1: (periodStart | luxonFormat: 'd MMMM y'),
                  arg2: (periodEnd | luxonFormat: 'd MMMM y'),
                }
        }}
      </p>
    }
    <dk-button
      class="gallery-change-period"
      data-testid="gallery-change-period"
      icon="ph-fill ph-calendar-blank"
      [label]="'doktar_app.common.select_a_period' | translate"
      severity="secondary"
      (onClick)="changePeriod.emit()" />
  </header>

  <p class="gallery-caption">{{ captionKey | translate }}</p>

  <div class="gallery-scroll" data-testid="gallery-scroll">
    @if (groups.length === 0 && emptyMessageKey) {
      <div class="gallery-empty" data-testid="gallery-empty">
        <i class="ph-bold ph-selection" aria-hidden="true"></i>
        <p>
          {{
            emptyMessageKey
              | translate
                : {
                    arg1: (periodStart | luxonFormat: 'd MMM y'),
                    arg2: (periodEnd | luxonFormat: 'd MMM y'),
                  }
          }}
        </p>
        @if (clearActionKey) {
          <dk-button
            data-testid="gallery-clear-period"
            [label]="clearActionKey | translate"
            (onClick)="clearPeriod.emit()" />
        }
      </div>
    } @else {
      <div class="gallery-groups">
        @for (group of groups; track group.key) {
          <section class="gallery-group">
            @if (group.label) {
              <h4>{{ group.label }}</h4>
            }
            <div class="gallery-items">
              @for (item of group.items; track item.id) {
                <button
                  type="button"
                  class="gallery-item"
                  data-testid="gallery-thumbnail-button"
                  [class.is-broken]="brokenImageIds.has(item.id)"
                  (click)="itemSelected.emit(item)">
                  <img data-testid="gallery-thumbnail" [src]="item.url" alt="" (error)="markImageAsBroken(item.id)" />
                  <i class="ph-bold ph-image-broken" aria-hidden="true"></i>
                </button>
              }
            </div>
          </section>
        }
      </div>

      @if (hasMore) {
        <div class="gallery-load-more" data-testid="gallery-load-more">
          <dk-button
            [label]="'doktar_app.common.load_more' | translate"
            [loading]="isLoadingMore"
            [disabled]="isLoadingMore"
            (onClick)="loadMore.emit()" />
        </div>
      }
    }
  </div>
</section>
